<template>
  <div v-if="isRelevant" class="asset-editor-transcript-controls">
    <div v-if="isAssetEditor" class="-cc-toggle">
      <div class="wt2-text-n2">
        <template v-if="subtitlesEnabled">
          Subtitles
          <div class="-explanation wt2-text-n">
            (will show on Full-Preview)
          </div></template
        >
        <template v-else> Include subtitles in SRT </template>
      </div>

      <wt-toggle :checked="AGD.showTranscription" @toggle="$_onToggleCC" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { isAssetCandidateForTranscribe } from 'v/Story/Timeline/api/transcription';

export default {
  name: 'asset-editor-video-transcript-controls',

  props: {
    asset: { type: Object, required: true },
  },

  computed: {
    ...mapState({
      transcriptions: (state) => state.story.transcriptions,
      enableVOSubtitles: (state) => state.story.enableVOSubtitles,
    }),
    ...mapState('assetEditor', ['openedFrom']),
    ...mapGetters('assetEditor', ['AGD']),

    isAssetEditor() {
      return this.openedFrom === 'timeline';
    },

    subtitlesEnabled() {
      return this.enableVOSubtitles;
    },

    isRelevant() {
      return isAssetCandidateForTranscribe(this.$props.asset);
    },
  },

  methods: {
    ...mapMutations('assetEditor', ['setAGD']),

    $_onToggleCC(value) {
      this.setAGD({ showTranscription: value });
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-editor-transcript-controls {
  margin-top: 30px;

  > .-cc-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;

    .-explanation {
      display: inline-block;
      position: relative;
      font-size: 14px;
      color: $color-grey-0;
    }
  }
}
</style>
